<div class="card-type-label type-label">{{ cardType() }}</div>
